<template>
    <v-dialog v-model="dialog" max-width="900" :persistent="true">
        <template #activator="{ on }">
          <v-btn v-on="on" color="info" :disabled="!canImport()">
            <span>{{ 'app.import_template' | trans}}</span>
          </v-btn>
        </template>
        <v-card>
          <v-toolbar card dark color="primary">
            <v-toolbar-title>{{ 'app.import_template' | trans}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark small @click="close">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
            <v-card-text>
                <templates-table>
                    <template #table-actions="item">
                        <icon-button
                                icon="cloud_download"
                                color="blue"
                                :permission="canImportSchema(item.item)"
                                :tooltip="{attach: false}"
                                :iconOptions="{small: true}"
                                @click="selectSchema(item.item)"
                        >
                            {{ 'app.schema_import' | trans}}
                        </icon-button>
                    </template>
                </templates-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="close">
                {{ 'app.close' | trans }}
              </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex';
  import {trans} from "../../app";
  import {DIETITIAN_FREE, DIETITIAN_TEST} from "../../utils/roles";

  export default {
    props: [
      'patientId',
    ],
    data: () => ({
      dialog: false,
    }),
    methods: {
      selectSchema(schema) {
        this.$confirmWarning(trans('app.menu.willing_to_scale')).then(() => {
          this.close();
          this.$emit('schemaSelected', {
            id: schema.id,
            desiredDietEnergy: schema.desired_diet_energy,
          });
        }).catch((error) => {
          this.importTemplate(schema);
          this.sentryCaptureException(error);
        });
      },
      importTemplate(schema) {
        axios.post(`/schemas/${this.patientId}/import`, {
          schema: schema.id,
          scale_products: false,
        }).then((response) => {
          window.location.href = response.data.url;
        });
      },
      close() {
        this.dialog = false;
      },
      canImport() {
        if ((this.userRole === DIETITIAN_FREE || this.userRole === DIETITIAN_TEST) && this.patientMenusCount >= 5) {
          return false;
        }
        return this.hasPermission('menu_schema_import');
      },
      canImportSchema(schema) {
        if (schema.days > 7 && !this.hasPermission('menu_schema_31_days')) {
          return false;
        }
        if (schema.system && this.hasPermission('schema_system_show')) {
          return true;
        }
        return !schema.system && this.hasPermission('schema_show');},
    },
    computed: {
      ...mapGetters(['hasPermission', 'userRole', 'patientMenusCount']),
    },
  };
</script>
